import * as actionTypes from '../actions/actionTypes';

export const selectedPicklistChanged =  (myParam) => {
    return {type: actionTypes.SELECTED_PICKLIST_CHANGED, payload: myParam};
}